/**
 * Redirects CF7 forms to success page after submit.
 *
 * @package KateMedia
 */

export function initCf7Redirect() {
  document.addEventListener('wpcf7mailsent', (event) => {
    try {
      const intent = window.__kmruPresentationSubmitIntent;
      const sentFromPresentation = !!intent?.formEl;
      const sentFromPopup = !!event?.target?.closest?.('#contact-popup');

      // Формы в модалке (#contact-popup): показ notice внутри попапа, без редиректа.
      // В т.ч. "Скачать презентацию" и "Оставить заявку" (#form-lead).
      if (sentFromPresentation || sentFromPopup) {
        window.__kmruPresentationSubmitIntent = null;
        return;
      }

      // Для остальных форм сохраняем текущую логику редиректа.
      const successUrl = window.kmruData?.cf7SuccessUrl;
      if (!successUrl) return;

      const currentUrl = window.location.href;
      if (currentUrl === successUrl) return;

      window.setTimeout(() => {
        window.location.href = successUrl;
      }, 900);
    } catch (_) {
      // no-op
    }
  });

  // В презентационной форме НЕ подавляем wpcf7redirect,
  // чтобы CF7 смог сам открыть файл презентации.
}
